import {
  CUSTOM_EMOJI_ID_ATTRIBUTE,
  CUSTOM_EMOJI_IMAGE_CLASS,
  CUSTOM_EMOJI_TAG
} from '../client';

const CUSTOM_EMOJI_SELECTOR = `${CUSTOM_EMOJI_TAG}[${CUSTOM_EMOJI_ID_ATTRIBUTE}]`;

/** Текст без тега разбирать не нужно: таких сообщений в истории большинство */
const hasCustomEmojiTag = (html: string): boolean =>
  html.includes(`<${CUSTOM_EMOJI_TAG}`);

const parseHtml = (html: string): DocumentFragment => {
  const template = document.createElement('template');
  template.innerHTML = html;

  return template.content;
};

/** Идентификаторы из тегов текста: по ним запрашиваются картинки */
export const collectCustomEmojiIds = (html: string): string[] => {
  if (!hasCustomEmojiTag(html)) {
    return [];
  }

  return Array.from(parseHtml(html).querySelectorAll(CUSTOM_EMOJI_SELECTOR))
    .map((node) => node.getAttribute(CUSTOM_EMOJI_ID_ATTRIBUTE) ?? '')
    .filter((customEmojiId) => customEmojiId.length > 0);
};

/**
 * Картинка на месте тега. Без картинки — ещё не загружена, её нет или запрос
 * не удался — на месте тега остаётся его содержимое, обычная замена.
 */
export const replaceCustomEmojiWithImages = ({
  html,
  getPreviewUrl
}: {
  html: string;
  getPreviewUrl: (customEmojiId: string) => string | null;
}): string => {
  if (!hasCustomEmojiTag(html)) {
    return html;
  }

  const content = parseHtml(html);

  content.querySelectorAll(CUSTOM_EMOJI_SELECTOR).forEach((node) => {
    const customEmojiId = node.getAttribute(CUSTOM_EMOJI_ID_ATTRIBUTE) ?? '';
    const previewUrl = getPreviewUrl(customEmojiId);
    const fallbackEmoji = node.textContent ?? '';

    if (previewUrl === null) {
      node.replaceWith(...Array.from(node.childNodes));

      return;
    }

    const image = document.createElement('img');
    image.src = previewUrl;
    image.alt = fallbackEmoji;
    image.className = CUSTOM_EMOJI_IMAGE_CLASS;
    node.replaceWith(image);
  });

  const wrapper = document.createElement('div');
  wrapper.appendChild(content);

  return wrapper.innerHTML;
};
